export const dummyAuctoinDescription = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla facilisi. 
    Curabitur varius, libero vel vehicula efficitur, justo sem mollis leo, a aliquam arcu eros a purus. 
    Suspendisse potenti. Vivamus non risus ac justo volutpat aliquet. 
    Fusce malesuada tellus a dolor condimentum, eget dignissim ligula fringilla. 
    Sed facilisis nibh ut turpis eleifend, sit amet efficitur nisl consectetur.`
